import script from "./schoolProblemFeedback.vue?vue&type=script&lang=ts&setup=true"
export * from "./schoolProblemFeedback.vue?vue&type=script&lang=ts&setup=true"

import "./schoolProblemFeedback.vue?vue&type=style&index=0&id=59445148&scoped=true&lang=css"

import exportComponent from "D:\\WorkFile\\Project\\uniapp-bajitu-user\\web-view\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59445148"]])

export default __exports__